//@@ Libs
import { Card, CardHeader, CardTitle, CardBody, CardFooter } from 'reactstrap'
import classNames from 'classnames'

//@@ Components
import Timeline from '@components/timeline'

const UserTimeline = ({ timeline, title = 'PROFILE TIMELINE', className = '' }) => {
  return (
    <Card className={classNames(className, 'mb-0')}>
      <CardHeader>
        <CardTitle tag="h4">{title}</CardTitle>
      </CardHeader>
      <CardBody className="pt-1">
        <Timeline data={timeline} className="ms-50" />
      </CardBody>
      <CardFooter className="font-medium-1">
        YouTube data displayed within SingleSource is sourced directly from the YouTube API and is presented as provided, without modification, combination, or aggregation with any other data.
        Metrics derived from YouTube data are generated independently by SingleSource and are not endorsed or verified by YouTube.
      </CardFooter>
    </Card>
  )
}

export default UserTimeline
